export * from "./TabGeneral";
export * from "./TabContent";
export * from "./TabRecipients";
export * from "./ITabProps";
